import { render } from "./Contact.vue?vue&type=template&id=d4121612&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=d4121612&lang=scss&scoped=true"
import "./Contact.vue?vue&type=style&index=1&id=d4121612&lang=scss&scoped=true"
import "./Contact.vue?vue&type=style&index=2&id=d4121612&lang=scss&scoped=true"
import "./Contact.vue?vue&type=style&index=3&id=d4121612&lang=scss&scoped=true"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4121612"]])

export default __exports__